// config.js - Configuration for different environments

// Feature flag: Stop membership selling toggle
// When true, shows deposit messaging instead of pricing and redirects CTAs to SeatGeek
// Toggle this value to enable/disable the feature
const STOP_MEMBERSHIP_SELLING = false;

// Canonical purchase destination for Quarter / Half / Full memberships.
// SeatGeek 2026-27 membership ticket-packages page (self-contained attribution).
const TICKET_PACKAGES_URL = "https://seatgeek.com/cleveland-cavaliers-tickets/ticket-packages?aid=15870&pid=web&rid=26272&utm_source=cavs&utm_medium=web&utm_campaign=2627membership&utm_content=enroll";

/**
 * Get the configuration based on the current environment
 * @returns {Object} Configuration object with API settings
 */
export function getConfig() {
    // Determine environment - can be set through build process or defaults to development
    const env = import.meta.env?.MODE || 'dev';
    
    // Base configurations
    const configs = {
      dev: {
        apiEndpoint: 'https://api1.cavs.com/survey-dev',
        apiKey: '49jg09j9asjhshij3aqjgmsrD',
        environment: 'development'
      },
      test: {
        apiEndpoint: 'https://api1.cavs.com/survey-test',
        apiKey: '49jg09j9asjhshij3aqjgmsrT',
        environment: 'test'
      },
      prod: {
        apiEndpoint: 'https://api1.cavs.com/survey',
        apiKey: '49jg09j9asjhshij3aqjgmsrP',
        environment: 'prod'
      }
    };
    
    // Return the config for the current environment, or development as fallback
    return {
      ...(configs[env] || configs.dev),
      stopMembershipSelling: STOP_MEMBERSHIP_SELLING,
      ticketPackagesUrl: TICKET_PACKAGES_URL
    };
  }
  
  // For local development/testing, add some mock data if needed
  export const MOCK_DATA = {
    recommendations: {
      'PREMIUM': {
        title: 'Premium Membership',
        description: 'Our most exclusive package with all perks included',
        price: '$10,000/season',
        benefits: [
          'Priority access to playoff tickets',
          'VIP entrance',
          'Exclusive events with players',
          'Premium seating'
        ]
      },
      'STANDARD': {
        title: 'Standard Membership',
        description: 'Great value for serious fans',
        price: '$5,000/season',
        benefits: [
          'Guaranteed regular season tickets',
          'Member-only merchandise',
          'Concession discounts'
        ]
      },
      'BASIC': {
        title: 'Basic Membership',
        description: 'Perfect for new fans',
        price: '$2,500/season',
        benefits: [
          'Access to ticket pre-sales',
          'Member communications',
          'Merchandise discounts'
        ]
      }
    }
  };